import { Theme, useTheme } from "@afterpaytouch/core";
import classNames from "classnames/bind";
import React from "react";

import { DropdownMenuItem } from "./dropdown-menu-items/dropdown-menu-item";
import { DropdownMenuItem as MenuItem } from "./dropdown-menu-items/dropdown-menu-item-interface";
import { KINDS } from "./dropdown-menu.constants";
import type { KIND, SIZE } from "./dropdown-menu.constants";
import styles from "./dropdownMenu.module.scss";

const cx = classNames.bind(styles);

export interface Props {
    dropdownMenuItems: Array<MenuItem>;
    kind: KIND;
    size?: SIZE;
    withBorder?: boolean;
    onClick?: (item: MenuItem) => void;
}

export const DropdownMenu: React.FC<Props> & {
    Text: React.FC<Props>;
    Country: React.FC<Props>;
} = (props: Props) => {
    const { dropdownMenuItems, kind, size, withBorder = true, onClick } = props;
    const theme = useTheme();
    const currentTheme = theme.theme.selected;
    const menuClassName = cx({
        [styles.dropdownMenuContainer]: true,
        [styles.dropdownMenuContainerBorder]: withBorder,
        [styles.arcade]: currentTheme === Theme.Cash,
    });

    return (
        <ul className={menuClassName} data-testid="menu">
            {dropdownMenuItems.map((item) => (
                <DropdownMenuItem
                    key={item.id}
                    id={item.id}
                    item={item}
                    kind={kind}
                    size={size}
                    onClick={onClick}
                />
            ))}
        </ul>
    );
};

const TextSelect: React.FC<Props> = (props: Props) => {
    return <DropdownMenu {...props} kind={KINDS.TEXT} />;
};

const CountrySelect: React.FC<Props> = (props: Props) => {
    return <DropdownMenu {...props} kind={KINDS.COUNTRY} />;
};

DropdownMenu.Text = TextSelect;
DropdownMenu.Country = CountrySelect;
